// This was generated during the migration to @kiwicom/eslint-config
// PLEASE REMOVE THE GLOBAL ESLINT DISABLE BELOW
// AND FIX ERRORS ACCORDINGLY.
/* eslint-disable new-cap, babel/new-cap */
import { Record, List, Map } from "immutable"

import { createDateRange, createNoReturn, isNoReturn, getId } from "./SearchDate/utils"
import { DEFAULT_CABIN_CLASS } from "./CabinClass"
import RESULTS_VIEW_TYPES from "../consts/resultViewTypes"
import SearchPlace from "./SearchPlace"
import MultiPlace from "./MultiPlace"
import PassengersCount from "./PassengersCount"
import type { SearchDate } from "./SearchDate/SearchDate"
import type Options from "./Options"
import type { CabinClass } from "./CabinClass"
import MulticityFormData from "./MulticityFormData"
import SalesmanFormData from "./SalesmanFormData"
import type { Index, SearchMode } from "./SearchFormState.types"

const SearchFormStateRecord = Record({
  outboundDate: createDateRange(new Date(), new Date(), true),
  inboundDate: createNoReturn(true),
  origin: new MultiPlace(),
  destination: new MultiPlace(),
  passengers: new PassengersCount(),
  cabinClass: DEFAULT_CABIN_CLASS,
  multicity: List(),
  salesman: Map({
    routes: List(),
    isReturnSame: true,
    setReturnDate: false,
  }),
  pastDateUpdated: false,
  searchModeUpdated: false,
  originTips: [],
  destinationTips: [],
})

class SearchFormState extends SearchFormStateRecord {
  // @ts-expect-error: Flow to TS migration.
  outboundDate: SearchDate

  // @ts-expect-error: Flow to TS migration.
  inboundDate: SearchDate

  // @ts-expect-error: Flow to TS migration.
  origin: MultiPlace

  // @ts-expect-error: Flow to TS migration.
  destination: MultiPlace

  // @ts-expect-error: Flow to TS migration.
  passengers: PassengersCount

  // @ts-expect-error: Flow to TS migration.
  cabinClass: CabinClass

  // @ts-expect-error: Flow to TS migration.
  multicity: List<MulticityFormData>

  // @ts-expect-error: Flow to TS migration.
  salesman: Map<{
    routes: List<SalesmanFormData>
    isReturnSame: boolean
    setReturnDate: boolean
  }>

  adjustPathForSalesman() {
    return this.getMode() === "salesman" ? ["salesman", "routes"] : ["multicity"]
  }

  // I'll just leave a few methods here to help ease us into a major refactoring…
  getPlace(field: "origin" | "destination", index?: Index): MultiPlace {
    const $index = this.parseIndex(index)
    return this.getIn(
      $index === undefined ? [field] : [...this.adjustPathForSalesman(), $index, field],
    )
  }

  parseIndex(index?: Index): number | null | undefined {
    if (this.getMode() === "multicity" || this.getMode() === "salesman") {
      if (index === "first") {
        return 0
      }
      if (index === "last") {
        if (this.getMode() === "salesman") {
          return 1
        }
        return this.getMode() === "salesman"
          ? this.getIn([this.getMode(), "routes"]).count() - 1
          : this.get(this.getMode()).count() - 1
      }
      return index
    }
    return undefined
  }
  // That's all ^^

  getSearchId(): string {
    // Fix this the next time the file is edited. (Flow to TS)
    // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
    return `${this.get("origin").getId()}|${this.get("destination").getId()}|${getId(
      this.get("outboundDate"),
    )}|${getId(this.get("inboundDate"))}`
  }

  getMode(): SearchMode {
    if (this.get("multicity").count()) {
      return "multicity"
    }
    if (this.getIn(["salesman", "routes"]).count()) {
      return "salesman"
    }
    if (isNoReturn(this.get("inboundDate"))) {
      return "oneWay"
    }
    return "return"
  }

  // @ts-expect-error: Flow to TS migration.
  useAggregateResults(options: Options) {
    return (
      this.getMode() !== "multicity" &&
      this.getMode() !== "salesman" &&
      (this.get("destination").isLarge() || this.get("destination").isEmpty()) &&
      options.get("preferredResultsView") !== RESULTS_VIEW_TYPES.LIST
    )
  }

  // @ts-expect-error: Flow to TS migration.
  isEmpty(index: number) {
    if (this.getMode() === "multicity") {
      const multicityTrip = this.multicity.get(index)

      // Fix this the next time the file is edited. (Flow to TS)
      // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition, @typescript-eslint/prefer-optional-chain
      return multicityTrip && multicityTrip.origin.isEmpty() && multicityTrip.destination.isEmpty()
    }
    return this.origin.isEmpty() && this.destination.isEmpty()
  }

  isLastDestinationEmpty() {
    return this.getPlace("destination", "last").isEmpty()
  }

  isDefault(): boolean {
    return (
      this.origin.isDefault() &&
      this.destination.isDefault() &&
      this.multicity.size === 0 &&
      this.outboundDate.isDefault &&
      this.inboundDate.isDefault
    )
  }

  // Fix this the next time the file is edited. (Flow to TS)
  // eslint-disable-next-line @typescript-eslint/member-ordering, @typescript-eslint/no-explicit-any
  static fromPlainJS(input: any) {
    return new SearchFormState({
      outboundDate: input.outboundDate,
      inboundDate: input.inboundDate,
      origin: MultiPlace.fromPlainJS(input.origin),
      destination: MultiPlace.fromPlainJS(input.destination),
      passengers: new PassengersCount(input.passengers),
      cabinClass: input.cabinClass,
      // Fix this the next time the file is edited. (Flow to TS)
      // eslint-disable-next-line @typescript-eslint/unbound-method
      multicity: List(input.multicity.map(MulticityFormData.fromPlainJS)),
      // Fix this the next time the file is edited. (Flow to TS)
      // eslint-disable-next-line @typescript-eslint/unbound-method
      originTips: input.originTips.map(SearchPlace.fromPlainJS),
      destinationTips: input.destinationTips,
      // @ts-expect-error: Flow to TS migration.
      salesman: new Map({
        // Fix this the next time the file is edited. (Flow to TS)
        // eslint-disable-next-line @typescript-eslint/unbound-method
        routes: List(input.salesman.routes.map(SalesmanFormData.fromPlainJS)),
        isReturnSame: input.isReturnSame,
        setReturnDate: input.setReturnDate,
      }),
    })
  }
}

export default SearchFormState
